export enum TermStepEnum {
  CANCELED = "CANCELED",
  DONE = "DONE",
  MEMBER_SIGNED = "MEMBER_SIGNED",
  OPTIONAL_SIGNATURES_COLLECTED = "OPTIONAL_SIGNATURES_COLLECTED",
  REJECTED = "REJECTED",
  REGISTER_CORRECTION = "REGISTER_CORRECTION",
  TIMED_OUT = "TIMED_OUT"
}
